import React, { useState } from "react";
import { useParams } from "react-router";
import Logo from "./Logo";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import NavLink from "./NavLink";
import UserMenu from "../userMenu/UserMenu";
import { useAuth } from "../../authentication/useAuth";
import Button from "../../button/Button";
import { MenuItem } from "../../../common/models";
import { PrivateRouteParams } from "../../../pages/invite/models";

const PrivateHeader: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();
  const { user } = useAuth();

  const [showMenu, setShowMenu] = useState(false);

  const params = useParams<PrivateRouteParams>();

  const prefix = `/${params.tenantCode}/${params.customerId}`;

  const menuItems: MenuItem[] = [
    {
      label: tCommon("menu_home"),
      path: prefix,
      end: true,
    },
    {
      label: tCommon("menu_orders"),
      path: `${prefix}/orders`,
    },
    {
      label: tCommon("menu_requests"),
      path: `${prefix}/requests`,
      hidden: !user?.isEditor,
    },
    {
      label: tCommon("menu_interventions"),
      path: `${prefix}/interventions`,
    },
    {
      label: tCommon("menu_serviceObjects"),
      path: `${prefix}/serviceObjects`,
    },
    {
      label: tCommon("menu_customer"),
      path: `${prefix}/customer`,
    },
    {
      label: tCommon("menu_contact"),
      path: `${prefix}/contact`,
    },
  ];

  return (
    <header className="flex h-22 flex-row items-center bg-white px-4 py-5 sm:h-26 sm:p-6">
      <Button
        icon={showMenu ? "close" : "menu"}
        className="bg-gray mr-4 p-2 sm:hidden"
        onClick={() => setShowMenu(!showMenu)}
      />
      <Logo />
      <nav>
        <ul
          className={`sm:ml-8 sm:flex sm:flex-row ${showMenu ? "absolute top-[88px] left-0 z-10 block w-full flex-col bg-white p-4" : "hidden"}`}
        >
          {menuItems
            .filter((x) => !x.hidden)
            .map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                children={item.label}
                closeMenu={() => setShowMenu(false)}
              />
            ))}
        </ul>
      </nav>
      <UserMenu />
    </header>
  );
};

export default PrivateHeader;
